import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { ContactForm } from '@/components/ContactForm';
import { MessageCircle } from 'lucide-react';

interface ContactDialogProps {
  trigger?: React.ReactNode;
  userEmail?: string;
  userName?: string;
}

export function ContactDialog({ trigger, userEmail, userName }: ContactDialogProps) {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger || (
          <button className="flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors">
            <MessageCircle className="h-4 w-4" />
            <span>Contact</span>
          </button>
        )}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <MessageCircle className="h-5 w-5 text-accent" />
            Contact Us
          </DialogTitle>
          <DialogDescription>
            Have a question or feedback? We'd love to hear from you.
          </DialogDescription>
        </DialogHeader>
        <ContactForm
          userEmail={userEmail}
          userName={userName}
          onSuccess={() => setTimeout(() => setOpen(false), 2000)}
        />
      </DialogContent>
    </Dialog>
  );
}
